import EtablissementLicenceValidite from '@/generated/controls/etablissement/EtablissementLicenceValidite.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: EtablissementLicenceValidite
})
